import { Layout }             from 'antd';
import Row                    from 'components/App/Row';
import { Col }                from 'antd';
import SwitchLanguage         from 'components/App/SwitchLanguage';
import type { CSSProperties } from 'react';

import logoUrl from '/images/logo.png?url';

const { Content, Footer } = Layout;

interface PublicLayoutProps {
  children?: any;
}

const PublicLayout = ({ children }: PublicLayoutProps) => (
  <Layout
    className="layout"
    style={{
      minHeight: '100vh',
      width: '100%',
    }}
  >
    <Content style={{ padding: '50px' }}>
      <Row
        align="middle"
        justify="center"
      >
        <Col lg={8} span={12}>
          <div
            className="accented-shadow"
            style={containerStyle}
          >
            <div className="public-layout-log-container">
              <img
                alt="logo"
                fetchPriority="high" // Force le téléchargement immédiat
                loading="eager"      // Empêche le lazy-loading sur cet élément critique
                src={logoUrl}
              />
            </div>
            <div className="login-children" style={childrenStyle}>
              {children}
            </div>
          </div>
        </Col>
      </Row>
    </Content>

    <Footer
      style={{
        alignItems: 'baseline',
        display: 'flex',
      }}
    >
      <div>Webcentric ©2019</div>
      <div
        style={{
          flex: 1,
          textAlign: 'right',
        }}
      >
        <SwitchLanguage />
      </div>
    </Footer>
  </Layout>
);

const containerStyle = {
  background: 'white',
  border: 'solid 1px #f5f5f5',
  textAlign: 'center',
} as CSSProperties;

const childrenStyle = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: '0px auto',
  maxWidth: '400px',
  minHeight: '300px',
  padding: 40,
} as CSSProperties;

export default PublicLayout;
